import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

async function deleteSession(
  sessionId: string,
  documentId: string
): Promise<void> {
  await Axios.delete(DELETE_URL(sessionId, documentId).deleteSession);
}

export function useDeleteTranscriptSession() {
  const queryClient = useQueryClient();

  return useMutation<
    void,
    AxiosError<BaseError>,
    { sessionId: string; documentId: string }
  >(
    ['deleteDocument'], // Mutation key for better error tracking
    async ({ sessionId, documentId }) => {
      await deleteSession(sessionId, documentId);
    },
    {
      onSuccess: async (_, { sessionId, documentId }) => {
        // Remove the document query from cache entirely instead of invalidating
        // This prevents 404 errors if user navigates to the deleted document
        queryClient.removeQueries(QueryKeys.document(sessionId, documentId));
        // Invalidate and refetch folder queries to update the workspace table
        await queryClient.invalidateQueries({
          queryKey: ['folders'],
          exact: false,
          refetchActive: true,
          refetchInactive: false
        });
        await queryClient.invalidateQueries({
          queryKey: ['folder'],
          exact: false,
          refetchActive: true,
          refetchInactive: false
        });
      }
    }
  );
}
